export class SendA2AMessageRequest {
    'id';
    'jsonrpc';
    'method';
    'params';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "jsonrpc",
            "baseName": "jsonrpc",
            "type": "SendA2AMessageRequestJsonrpcEnum",
            "format": ""
        },
        {
            "name": "method",
            "baseName": "method",
            "type": "SendA2AMessageRequestMethodEnum",
            "format": ""
        },
        {
            "name": "params",
            "baseName": "params",
            "type": "any",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SendA2AMessageRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var SendA2AMessageRequestJsonrpcEnum;
(function (SendA2AMessageRequestJsonrpcEnum) {
    SendA2AMessageRequestJsonrpcEnum["_20"] = "2.0";
})(SendA2AMessageRequestJsonrpcEnum || (SendA2AMessageRequestJsonrpcEnum = {}));
export var SendA2AMessageRequestMethodEnum;
(function (SendA2AMessageRequestMethodEnum) {
    SendA2AMessageRequestMethodEnum["MessageSend"] = "message/send";
    SendA2AMessageRequestMethodEnum["MessageStream"] = "message/stream";
    SendA2AMessageRequestMethodEnum["TasksGet"] = "tasks/get";
    SendA2AMessageRequestMethodEnum["TasksCancel"] = "tasks/cancel";
})(SendA2AMessageRequestMethodEnum || (SendA2AMessageRequestMethodEnum = {}));
